import { useEffect, useState } from "react";
import { Box } from "@mantine/core";

const TINT_PALETTE = [
  { bg: "var(--mantine-color-teal-light)", fg: "var(--mantine-color-teal-7)" },
  { bg: "var(--mantine-color-blue-light)", fg: "var(--mantine-color-blue-7)" },
  { bg: "var(--mantine-color-grape-light)", fg: "var(--mantine-color-grape-7)" },
  { bg: "var(--mantine-color-orange-light)", fg: "var(--mantine-color-orange-7)" },
  { bg: "var(--mantine-color-cyan-light)", fg: "var(--mantine-color-cyan-7)" },
  { bg: "var(--mantine-color-lime-light)", fg: "var(--mantine-color-lime-7)" },
];

const tintForId = (id) => {
  const n = Math.abs(Number(id) || 0);
  return TINT_PALETTE[n % TINT_PALETTE.length];
};

const initialsOf = (text) => {
  if (!text) return "?";
  return text
    .split(/[\s_-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
};

const OrgLogo = ({ org, size = 28, src, square = true }) => {
  const tint = tintForId(org?.id);
  const radius = square ? 6 : 999;
  const imgSrc = src ?? org?.logoPath;
  const [imgFailed, setImgFailed] = useState(false);

  // Reset on source change so a new logo is re-attempted - the active badge
  // reuses a single OrgLogo instance across org switches.
  useEffect(() => {
    setImgFailed(false);
  }, [imgSrc]);

  if (imgSrc && !imgFailed) {
    return (
      <Box
        style={{
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: radius,
          overflow: "hidden",
          backgroundColor: "var(--mantine-color-default)",
          border: "1px solid var(--mantine-color-default-border)",
          display: "grid",
          placeItems: "center",
        }}
      >
        <img
          src={imgSrc}
          alt=""
          onError={() => setImgFailed(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: radius,
        backgroundColor: tint.bg,
        color: tint.fg,
        display: "grid",
        placeItems: "center",
        fontSize: Math.round(size * 0.4),
        fontWeight: 700,
        letterSpacing: "0.02em",
        fontFamily: "var(--mantine-font-family-monospace)",
      }}
    >
      {initialsOf(org?.fullName || org?.shortName || "?")}
    </Box>
  );
};

export default OrgLogo;
